<ion-header>
  <ion-toolbar>
    <ion-title>Bestellen</ion-title>
  </ion-toolbar>
  <ion-item class="ion-text-wrap" style="background-color: var(--ion-background-color);" lines="none">
    <ion-label >
      <h1>Vielen Dank für Ihren Einkauf</h1>
      Die Ware wurde bestellt!
    </ion-label>
  </ion-item>
  <ion-row style="background-color: var(--ion-background-color); font-size: small; font-weight: bold;">
    <ion-col size="2">Eh</ion-col>
    <ion-col size="2">VPE</ion-col>
    <ion-col size="2">Preis</ion-col>
    <ion-col size="preisAnzeigen ? 6 : 8">Bezeichnung</ion-col>
  </ion-row>
</ion-header>

<ion-content>
  <ion-row *ngFor="let artikel of positionen">
    <ion-col size="2">{{artikel.pos.eh}}</ion-col>
    <ion-col size="2">{{artikel.vpe}}</ion-col>
    <ion-col size="2" *ngIf="preisAnzeigen">{{artikel.vkPreis.toFixed(2).replace('.', ',')}}</ion-col>
    <ion-col size="preisAnzeigen ? 6 : 8">{{artikel.bezeichnung}}</ion-col>
  </ion-row>
</ion-content>

<ion-footer>
  <ion-item class="ion-text-wrap" style="background-color: var(--ion-background-color);" lines="none">
    <ion-label>
      Einheiten: {{orderResponse.einheiten}}<br>
      <span style="font-weight: bold;" *ngIf="preisAnzeigen">Warenwert: {{orderResponse.warenwert.toFixed(2).replace('.', ',')}} €</span>
    </ion-label>
  </ion-item>
  <ion-item style="background-color: var(--ion-background-color);">
    <ion-label>
      {{orderResponse.bemerkung}}<br>
    </ion-label>
  </ion-item>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button (click)="schliessen()" expand="full">
          <ion-icon slot="start" name="close"></ion-icon>
          Schließen
        </ion-button>
        </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>